import dayjs from 'dayjs';
import {getPrimitive} from '@tickchak/react-share/app';

export type PlanType = 'closed' | 'open' | 'mixed' | 'gift_card';
export const formatDate = (date?: string | number): string => {
    if(!date) return '';
    return dayjs(date).format('DD.MM.YY');
};

export const seriesTypeLabel = {
    open: {color: getPrimitive('pinks.pink50'), label: 'openSeries'},
    closed: {color: getPrimitive('turquoise.turquoise100'), label: 'closedSeries'},
    mixed: {color: getPrimitive('greens.green50'), label: 'combinedSeries'},
    gift_card: {color: getPrimitive('yellow.yellow50'), label: 'giftCard'},
};

